import { render } from "./SimpleInfoPopup.vue?vue&type=template&id=10b27900&scoped=true"
import script from "./SimpleInfoPopup.vue?vue&type=script&lang=js"
export * from "./SimpleInfoPopup.vue?vue&type=script&lang=js"

import "./SimpleInfoPopup.vue?vue&type=style&index=0&id=10b27900&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b27900"]])

export default __exports__